import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import toast from 'react-hot-toast';
import LoadingSpinner from '../components/LoadingSpinner';

const EmployeesAdd = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { user: currentUser } = useAuth();
  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    defaultValues: {
      active: true
    }
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const employeeData = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: data.phoneNumber || null,
        position: data.position || null,
        active: data.active !== undefined ? data.active : true
      };

      await api.post('/employees', employeeData);
      toast.success('Pracownik został dodany pomyślnie');
      reset();
      navigate('/app/hr/employees/list');
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Błąd podczas dodawania pracownika';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-xl">Dodaj pracownika</h2>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="firstName" className="block text-sm text-gray-700 mb-2">
                Imię <span className="text-red-500">*</span>
              </label>
              <input
                {...register('firstName', {
                  required: 'Imię jest wymagane',
                  minLength: {
                    value: 2,
                    message: 'Imię musi mieć co najmniej 2 znaki'
                  }
                })}
                type="text"
                id="firstName"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                placeholder="Jan"
              />
              {errors.firstName && (
                <p className="mt-1 text-sm text-red-600">{errors.firstName.message}</p>
              )}
            </div>

            <div>
              <label htmlFor="lastName" className="block text-sm text-gray-700 mb-2">
                Nazwisko <span className="text-red-500">*</span>
              </label>
              <input
                {...register('lastName', {
                  required: 'Nazwisko jest wymagane',
                  minLength: {
                    value: 2,
                    message: 'Nazwisko musi mieć co najmniej 2 znaki'
                  }
                })}
                type="text"
                id="lastName"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                placeholder="Kowalski"
              />
              {errors.lastName && (
                <p className="mt-1 text-sm text-red-600">{errors.lastName.message}</p>
              )}
            </div>
          </div>

          <div>
            <label htmlFor="email" className="block text-sm text-gray-700 mb-2">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              {...register('email', {
                required: 'Email jest wymagany',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'Nieprawidłowy adres email'
                }
              })}
              type="email"
              id="email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
              placeholder="jan.kowalski@example.com"
            />
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email.message}</p>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="phoneNumber" className="block text-sm text-gray-700 mb-2">
                Telefon
              </label>
              <input
                {...register('phoneNumber')}
                type="text"
                id="phoneNumber"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                placeholder="+48 123 456 789"
              />
            </div>

            <div>
              <label htmlFor="position" className="block text-sm text-gray-700 mb-2">
                Stanowisko
              </label>
              <input
                {...register('position')}
                type="text"
                id="position"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
                placeholder="np. Programista"
              />
            </div>
          </div>

          <div>
            <label htmlFor="active" className="block text-sm text-gray-700 mb-2">
              Status
            </label>
            <select
              {...register('active')}
              id="active"
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            >
              <option value={true}>Aktywny</option>
              <option value={false}>Nieaktywny</option>
            </select>
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <button
              type="button"
              onClick={() => navigate('/app/hr/employees/list')}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Anuluj
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <LoadingSpinner size="sm" />
                  Dodawanie...
                </span>
              ) : (
                'Dodaj pracownika'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeesAdd;
